import { Alert, CircularProgress, Stack } from '@mui/material';
import { Component, Suspense, lazy } from 'react';

const NotificationPage = lazy(() => import('notificationMicrofrontend/NotificationPage'));

interface RemoteBoundaryProps {
  children: React.ReactNode;
}

interface RemoteBoundaryState {
  hasError: boolean;
}

class RemoteBoundary extends Component<RemoteBoundaryProps, RemoteBoundaryState> {
  state: RemoteBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RemoteBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    console.error('Notification microfrontend failed to render:', error);
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <Alert severity='warning'>Notifications are temporarily unavailable.</Alert>;
    }

    return children;
  }
}

const Notifications = (): React.ReactElement => (
  <RemoteBoundary>
    <Suspense
      fallback={
        <Stack
          alignItems='center'
          padding={4}
        >
          <CircularProgress />
        </Stack>
      }
    >
      <NotificationPage />
    </Suspense>
  </RemoteBoundary>
);

export default Notifications;
